const configs = new WeakMap();

export const setWatermarkContainerConfig = (node, config) => {
  if (!node) {
    return;
  }

  configs.set(node, {
    offsetTop: config.offsetTop != null ? config.offsetTop : 8,
    left: config.left,
    leftMobile: config.leftMobile || config.left,
  });
};

export const getWatermarkContainerConfig = node => {
  if (!node) {
    return null;
  }

  return configs.get(node) || null;
};

export const clearWatermarkContainerConfig = node => {
  if (!node) {
    return;
  }

  configs.delete(node);
};
